var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProfilePageStoreWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.7368C14.9651 10.7368 17.3686 8.33329 17.3686 5.36841C17.3686 2.40352 14.9651 0 12.0002 0C9.03535 0 6.63184 2.40352 6.63184 5.36841C6.63184 8.33329 9.03535 10.7368 12.0002 10.7368Z",
    fill: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C6.7679 12 2.52637 16.2416 2.52637 21.4737C2.52637 22.8689 3.65746 24 5.0527 24H18.9474C20.3427 24 21.4738 22.8689 21.4738 21.4737C21.4737 16.2416 17.2322 12 12 12Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfilePageStoreWeb);
export default __webpack_public_path__ + "static/media/my-profile-page-store-web.3871fe951bb00f37f67a29707fbbe8b3.svg";
export { ForwardRef as ReactComponent };